import { render } from "./QuizOverview.vue?vue&type=template&id=4b4bbfa6&scoped=true"
import script from "./QuizOverview.vue?vue&type=script&lang=js"
export * from "./QuizOverview.vue?vue&type=script&lang=js"

import "./QuizOverview.vue?vue&type=style&index=0&id=4b4bbfa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4bbfa6"]])

export default __exports__